import { render, staticRenderFns } from "./metadata.vue?vue&type=template&id=570b9aa8&scoped=true&"
import script from "./metadata.vue?vue&type=script&lang=js&"
export * from "./metadata.vue?vue&type=script&lang=js&"
import style0 from "./metadata.vue?vue&type=style&index=0&id=570b9aa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b9aa8",
  null
  
)

export default component.exports